const coding = `
### When the Coding step appears

On home health cases, the Coding step appears after the review and shows codes suggested from the verified facts. The panel is headed Suggested ICD-10-CM Diagnosis Codes and names the CMS fiscal-year tables in use. The codes are suggestions. Verify each one against the cited evidence; you make the final coding decision.

### What each code shows

- The code and its description.
- Evidence quoted from the documents, with the document name and page. If none is found, the card says so and asks you to verify before billing.
- Clinical group under PDGM, and whether the code is acceptable as a primary diagnosis.
- A PDGM comorbidity chip when the code belongs to a subgroup.
- A warning when the code is a category heading rather than a billable code, or is not in the current code set.

### Select, dismiss, or refine

Select adds the code to the case. Dismiss records that it does not apply. Refine opens the code search so you can swap it for a more specific code; the original stays on the list as dismissed, which keeps the audit trail.

### Primary diagnosis

Every selected code carries a Primary diagnosis choice. A warning appears if the chosen primary is not acceptable under PDGM, because Medicare returns the claim until it is recoded. Pick a documented, acceptable primary or query the physician.

### Look up a code

Look up code opens a search by condition, code, or phrase. Results are marked Billable or Header. Browse opens the hierarchy to find more specific codes. Details shows a code with Check evidence in documents and Add to case. When you add a code, the app checks it against the other codes on the case for Excludes1 conflicts and records any it finds.

### Needs documentation

A Needs documentation card means the documents support a condition but not a specific code. Copy physician query puts a draft query on the clipboard: the clinical indicator from the record with its source, the fact that needs clarifying, and check boxes for the physician to answer. The draft never mentions payment.

### The unchecked notice

If the automatic code check did not run, a notice says the codes below are unchecked model suggestions. Review them with extra care, or click Re-suggest codes from verified context to run the suggestion again. Re-suggesting replaces the current list, including your selections.

### Copy the code list

Copy code list places the selected codes on the clipboard, one per line, primary first.
`;

export default coding;
